<template>
  <div :class="['definition-builder', definition.id]">
    <!-- questions searcher -->
    <transition name="fade" mode="out-in">
      <div :class="['drag', 'w3-row', 'questions_searcher', {'questions_searcher_fixed': this.questionsSearcherContainerFixed}]" ref="questions_searcher">
        <div class="searcher-input">
          <input v-model="questionSearcher" @input="doQuestionsSearch()" />
          <i class="sherpa-icon icon-buscar"></i>
          <transition name="fade" mode="out-in">
            <div class="searcher-count-results">{{ questionSearcherCount }}/{{ questionSearcherTotal }} {{ $ml.get('questions') }}</div>
          </transition>
        </div>
        <definition-multilanguage
          :definition="sectionDefinitionTitle" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
          @newLanguageSelected="newLanguageSelected" @translate="translate" @copy="copy"
        />
        <transition name="fade" mode="out-in">
          <simplebar data-simplebar-auto-hide="false">
            <draggable
              v-show="!isEditingQuestion"
              :list="definitionQuestions"
              item-key="key"
              v-bind="{group : {name: 'questions'}}"
              :move="checkMove"
              @start="onStartDrag"
              @end="onEndDrag">
              <template #item="{ element: question }">
                <div v-show="question.show" :key="question.key" :id="question.key"
                  class="questions"
                >
                  <transition name="fade" mode="out-in">
                    <span>{{question.value}}<br/><span class="key">{{question.key}}</span></span>
                  </transition>
                </div>
              </template>
            </draggable>
          </simplebar>
        </transition>
      </div>
    </transition>
    <!-- END questions searcher -->

    <div class="definition-wrappers">
      <simplebar data-simplebar-auto-hide="false">

        <!-- Sections -->
        <transition-group name="fade" tag="div">
          <div v-for="(section, sectionIdx) in sectionWrappers" :key="section.id" class="work-flow section_wrapper">
            <!-- section title -->
            <transition name="fade" mode="out-in">
              <definition-text v-if="formGroupInitiated"
                :placeholder="section.definition.label" :definition="section.definition" :object="section.object" :editable="true" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="false"
                :language="language" :visualDefinition="visualDefinition" :apiparams="apiparams"
                @validateMandatory="validateMandatory"
              />
            </transition>

            <!-- Groups -->
            <transition-group name="fade" tag="div">
              <draggable
                title="group"
                :class="['groups-drag-area', 'w3-row', {'formGroupInitiated': formGroupInitiated}]"
                v-for="group in section.children"
                :key="group.id"
                :list="group.children"
                item-key="key"
                v-bind="{group:{ name: 'questions'}, disabled: isEditingQuestion}"
                :id="section.id + '-' + group.id"
                @start="onStartDrag"
                @end="onEndDrag">

                <!-- Questions -->
                <template #item="{ element: question }">
                <div :key="question.key" class="questions selected" :id="question.key">
                  <definition-builder-question
                    :question="question"
                    :language="language"
                    :languageSelected="languageSelected"
                    :mandatoryValidation="mandatoryValidation"
                    :definitionId="definitionId"
                    :definitionContentId="definitionContentId"
                    :repeatableGroupCode="repeatableGroupCode"
                    :visualDefinition="visualDefinition"
                    :apiparams="apiparams"
                    :authorization="authorization"
                    :type="type"
                    :visuals="visuals"
                    :isEditingQuestion="isEditingQuestion"
                    @validateMandatory="validateMandatory"
                    @refreshDefinitionContent="refreshDefinitionContent"
                    @editingQuestion="editingQuestion"
                    @questionDeleted="questionDeleted"
                    @taskLink="taskLink"
                  />
                </div>
                </template>
                <!-- END questions -->

                <!-- group title -->
                <!--
                <transition name="fade" mode="out-in" slot="header">
                  <input v-if="formGroupInitiated" v-model="group.id" />
                </transition>
                -->
              </draggable>
            </transition-group>
            <!-- END Groups -->

            <!-- Add items on empty definition -->
            <transition name="fade" mode="out-in">
              <div v-if="!formGroupInitiated" class="add_items">
                <img src="../../../img/fletxa_form.png">
                <span>{{ $ml.get('infoNewForm') }}</span>
              </div>
            </transition>
            <!-- END Add items on empty definition -->

            <!-- Section Tasks -->
            <transition-group v-if="formGroupInitiated && section.tasks" name="fade">
              <span class="sectionTaskTitle" key="title">{{getLang('sectionTasks')}}</span>
              <draggable
                title="task"
                :class="[]"
                v-model="section.tasks"
                item-key="object"
                v-bind="{group:{ name: 'tasks'}, disabled: isEditingQuestion}"
                :id="section.id + '-tasks'"
                @end="onEndTaskDrag"
                :key="section.id + '-taskDraggable'"
              >
                <template #item="{ element, index: taskIdx }">
                  <div>
                  <definition-builder-task v-if="formGroupInitiated"
                    :key="section.id + '-task-' + taskIdx"
                    :object="element.object"
                    :definition="sectionTaskDefinition"
                    :definitionId="definitionId"
                    :language="language"
                    :type="type"
                    :languageSelected="languageSelected"
                    :definitionContentId="definitionContentId"
                    :visualDefinition="visualDefinition"
                    :authorization="authorization"
                    :visuals="visuals"
                    :apiparams="apiparams"
                    :sectionIdx="sectionIdx"
                    :taskIdx="taskIdx"
                    @deleteTask="deleteTask"
                    @refreshTask="refreshTask"
                  />
                  </div>
                </template>
              </draggable>
              <button :key="section.id + '-addTask'" class="addSectionTask" @click="addTask(sectionIdx)"><i class="sherpa-icon icon-anadir"></i> {{getLang('addTask')}}</button>
            </transition-group>
            <!-- END Section Tasks -->
          </div>
        </transition-group>
        <!-- END Sections -->
      </simplebar>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DefinitionTask from '../../task'
import DefinitionMultilanguage from '../../multilanguage'
import DefinitionBuilderQuestion from './definitionBuilderQuestion'
import DefinitionBuilderTask from './definitionBuilderTask'
import DefinitionText from '../../text'
import transport from 'vue-definition-utils/src/utils/transport'
import translate from '../../../utils/translate'
import moment from 'moment'
import language from '../../../language'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

const QUESTIONS_SEARCHER_RESULTS = 25
const DEFINITON_SECTION_ID = 'appsur_cuestionarios_questsection'

const DEFINITON_SECTION_TASK_ID = 'appsur_cuestionarios_questsectiontask'
const DEFINITON_SECTION_TASKID_ID = 'appsur_cuestionarios_questsectiontaskid'
const DEFINITON_SECTION_TASKNAME_ID = 'appsur_cuestionarios_questsectiontaskname'
const DEFINITON_SECTION_TASKDESC_ID = 'appsur_cuestionarios_questsectiontaskdesc'
const DEFINITON_SECTION_TASKSCOPE_ID = 'appsur_cuestionarios_questsectiontaskscope'
const DEFINITON_SECTION_TASKSTATE_ID = 'appsur_cuestionarios_questsectiontaskstate'
const DEFINITON_SECTION_TASKTYPE_ID = 'appsur_cuestionarios_questsectiontasktype'
const DEFINITON_SECTION_TASKPERSIST_ID = 'appsur_cuestionarios_questsectiontaskpersist'
const DEFINITON_SECTION_TASKENDPOINT_ID = 'appsur_cuestionarios_questsectiontaskendpoint'
const DEFINITON_SECTION_TASKMENUID_ID = 'appsur_cuestionarios_questsectiontaskmenuid'

const DEFINITON_GROUP_ID = 'appsur_cuestionarios_questgroup'
const DEFINITON_QUESTION_ID = 'appsur_cuestionarios_questquestion'
const DEFINITON_SECTION_TITLE_ID = 'appsur_cuestionarios_questsectiontitle'
const DEFINITON_GROUP_TITLE_ID = 'appsur_cuestionarios_questgrouptitle'
const DEFINITON_QUESTION_TITLE_ID = 'appsur_cuestionarios_questquestiontitle'
const DEFINITON_QUESTION_ALIAS_ID = 'appsur_cuestionarios_questalias'

export default {
  name: 'definition-builder',
  props: [
    'definition',
    'object',
    'languageSelected',
    'language',
    'apiparams',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'visualDefinition',
    'questions',
    'authorization',
    'type',
    'visuals'
  ],
  components: {
    draggable,
    simplebar,
    DefinitionMultilanguage,
    DefinitionBuilderQuestion,
    DefinitionBuilderTask,
    DefinitionText,
    DefinitionTask
  },
  data () {
    return {
      definitionQuestions: [],
      sectionWrappers: null,
      formGroupInitiated: false,
      questionSearcher: '',
      questionSearcherCount: 0,
      questionSearcherTotal: 0,
      detailContainer: null,
      questionsSearcherContainerFixed: false,
      sectionDefinition: null,
      sectionTaskDefinition: null,
      groupDefinition: null,
      questionDefinition: null,
      sectionDefinitionTitle: null,
      groupDefinitionTitle: null,
      questionDefinitionTitle: null,
      questionDefinitionAlias: null,
      translating: false,
      mandatoryValidation: null,
      isEditingQuestion: false
    }
  },
  beforeMount () {
    this.initDefinitionBuilder()
  },
  mounted () {
    this.questionsSearcherContainerFixed = true
  },
  beforeUnmount () {
    this.questionsSearcherContainerFixed = false
  },
  methods: {
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    onStartDrag () {
      this.formGroupInitiated = true
      var sections = this.sectionWrappers
      var newSection = this.newSection(false)
      var newGroup = {}

      for (var i = 0; i < sections.length; i++) {
        var numGroups = sections[i].children.length - 1
        newGroup = this.newGroup(false)
        var numPreguntes = sections[i].children[numGroups].children.length - 1
        if (numPreguntes >= 0) {
          sections[i].children.push(newGroup)
          if (i === sections.length - 1) {
            this.sectionWrappers.push(newSection)
          }
        }
      }
    },
    onEndDrag (elementDragged) {
      // check if question is erasable
      if (elementDragged.to.className === 'questions-drag-area' && elementDragged.to.className !== elementDragged.from.className) {
        this.replaceQuestionForDelete(elementDragged)
      }
      this.refreshSections()
    },
    onEndTaskDrag (elementDragged) {
      this.refreshRepeatableGroup()
    },
    replaceQuestionForDelete (questionDragged) {
      var questionKey = questionDragged.item.id
      var fromSplitted = questionDragged.from.id.split('-')
      var sectionKey = fromSplitted[0]
      var groupKey = fromSplitted[1]
      var groupIndexOrder = questionDragged.oldIndex
      var question = null

      // reposition on origin group for delete condition check
      for (var i = 0; i < this.definitionQuestions.length && !question; i++) {
        if (this.definitionQuestions[i].key === questionKey) {
          question = this.definitionQuestions[i]
          this.definitionQuestions.splice(i, 1)
        }
      }
      if (question) {
        var placed = false
        for (var j = 0; j < this.sectionWrappers.length && !placed; j++) {
          var section = this.sectionWrappers[j]
          if (section.id === sectionKey) {
            for (var k = 0; k < section.children.length && !placed; k++) {
              var group = section.children[k]
              if (group.id === groupKey) {
                question.forDelete = true
                group.children.splice(groupIndexOrder, 0, question)
                placed = true
              }
            }
          }
        }
      }
    },
    refreshSections () {
      var sections = this.sectionWrappers
      var newSections = []
      var newSection = this.newSection(false)
      var deletedGroups = []
      for (var i = 0; i < sections.length; i++) {
        for (var j = 0; j < sections[i].children.length; j++) {
          if (sections[i].children[j].children.length - 1 < 0 && j !== 0) {
            deletedGroups.push([i, j])
          }
        }
      }
      for (var a = 0; a < sections.length; a++) {
        for (var y = deletedGroups.length - 1; y >= 0; y--) {
          if (a === deletedGroups[y][0]) {
            sections[a].children.splice(deletedGroups[y][1], 1)
          }
        }
      }
      for (var z = 0; z < sections.length; z++) {
        if (sections[z].children.length - 1 !== 0 || sections[z].children[0].children.length - 1 >= 0) {
          newSections.push(sections[z])
        }
      }
      if (sections[0].children[0].children.length - 1 < 0) {
        sections[0].children.splice(0, 1)
      }
      if (newSections.length - 1 < 0) {
        this.formGroupInitiated = false
        newSections.push(newSection)
      }
      this.sectionWrappers = newSections

      this.doQuestionsSearch()
      this.refreshRepeatableGroup()
    },
    checkMove (resp) {
      // console.log(resp)
    },
    initDefinitionBuilder () {
      this.formGroupInitiated = false

      this.sectionDefinition = transport.methods.getRequestDefinitionById(DEFINITON_SECTION_ID, [this.definition])
      this.sectionTaskDefinition = transport.methods.getRequestDefinitionById(DEFINITON_SECTION_TASK_ID, [this.definition])
      this.groupDefinition = transport.methods.getRequestDefinitionById(DEFINITON_GROUP_ID, [this.definition])
      this.questionDefinition = transport.methods.getRequestDefinitionById(DEFINITON_QUESTION_ID, [this.definition])
      this.sectionDefinitionTitle = transport.methods.getRequestDefinitionById(DEFINITON_SECTION_TITLE_ID, [this.definition])
      this.groupDefinitionTitle = transport.methods.getRequestDefinitionById(DEFINITON_GROUP_TITLE_ID, [this.definition])
      this.questionDefinitionTitle = transport.methods.getRequestDefinitionById(DEFINITON_QUESTION_TITLE_ID, [this.definition])
      this.questionDefinitionAlias = transport.methods.getRequestDefinitionById(DEFINITON_QUESTION_ALIAS_ID, [this.definition])

      if (this.questions) {
        if (!this.object.children || this.object.children.length === 0) {
          this.sectionWrappers = [this.newSection(true)]
        } else {
          this.sectionWrappers = this.getSectionWrappers(this.object.children)
          this.formGroupInitiated = true
        }

        var notUsedQuestions = []
        for (var i = 0; i < this.questions.length; i++) {
          var question = this.questions[i]
          if (!this.aliasUsed(question.key)) {
            var questionObject = transport.methods.getEmptyRequestObject([this.questionDefinitionAlias])[0]
            questionObject.domainValue = [question]
            questionObject = this.setQuestionInfo(questionObject)
            notUsedQuestions.push(JSON.parse(JSON.stringify(questionObject)))
          }
        }
        this.definitionQuestions = JSON.parse(JSON.stringify(notUsedQuestions))

        if (this.definitionQuestions) {
          this.doQuestionsSearch()
        }
      }

      this.refreshRepeatableGroup()
    },
    getSectionWrappers (objectSections) {
      var sections = []

      for (var i = 0; i < objectSections.length; i++) {
        var section = objectSections[i]

        var sectionWrapper = {
          id: 'section' + i,
          definition: this.getDefinitionSectionTitle(),
          object: this.getObjectSectionTitle(section),
          type: 'section',
          children: this.getGroupWrappers(transport.methods.getRequestObjectById(DEFINITON_GROUP_ID, [section]).children),
          tasks: this.getSectionTasks(transport.methods.getRequestObjectById(DEFINITON_SECTION_TASK_ID, [section]))
        }

        sections.push(sectionWrapper)
      }

      return sections
    },
    getSectionTasks (objectTasks) {
      var tasks = null

      if (objectTasks) {
        tasks = []
        for (var i = 0; i < objectTasks.children.length; i++) {
          var task = {
            object: JSON.parse(JSON.stringify(objectTasks.children[i]))
          }

          tasks.push(task)
        }
      }
      return tasks
    },
    getGroupWrappers (objectGroups) {
      var groups = []

      for (var i = 0; i < objectGroups.length; i++) {
        var group = objectGroups[i]

        var groupWrapper = {
          id: 'group' + i,
          definition: this.getDefinitionGroupTitle(),
          object: this.getObjectGroupTitle(group),
          type: 'group',
          children: this.getQuestionWrappers(transport.methods.getRequestObjectById(DEFINITON_QUESTION_ID, [group]).children)
        }

        groups.push(groupWrapper)
      }

      return groups
    },
    getQuestionWrappers (objectQuestions) {
      var questions = []

      for (var i = 0; i < objectQuestions.length; i++) {
        var objectQuestion = objectQuestions[i]

        var aliasDomainValue = transport.methods.getRequestObjectById(DEFINITON_QUESTION_ALIAS_ID, [objectQuestion])
        aliasDomainValue = this.setQuestionInfo(aliasDomainValue, objectQuestion)

        questions.push(aliasDomainValue)
      }

      return questions
    },
    setQuestionInfo (aliasDomainValue, objectQuestion) {
      var questionDomainCopy = JSON.parse(JSON.stringify(aliasDomainValue.domainValue[0]))
      var question = aliasDomainValue.domainValue[0]
      question.definition = this.getDefinitionQuestionTitle()
      question.object = this.getObjectQuestionTitle(objectQuestion)
      if (!question.object.domainValue) {
        question.object.domainValue = []
      }
      question.object.domainValue.push(questionDomainCopy)
      question.objectAlias = JSON.parse(JSON.stringify(aliasDomainValue))
      if (!objectQuestion) {
        question.object = transport.methods.setLanguageValue(question.object, question.value, this.language.isoCode)
      }
      question.task = this.questionDefinitionAlias.task
      question.embeddedDefinition = {
      }
      question.forDelete = false
      return question
    },
    newSection (initial) {
      var suffix
      if (initial) {
        suffix = '1'
      } else {
        suffix = Math.floor((Math.random() * 10000) + 1)
      }

      var tasks = null
      if (this.sectionTaskDefinition) {
        tasks = []
      }

      return {
        id: 'section' + suffix,
        definition: this.getDefinitionSectionTitle(),
        object: this.getObjectSectionTitle(),
        type: 'section',
        children: [
          this.newGroup(true)
        ],
        tasks: tasks
      }
    },
    newGroup (initial) {
      var suffix
      if (initial) {
        suffix = '1'
      } else {
        suffix = Math.floor((Math.random() * 10000) + 1)
      }

      return {
        id: 'group' + suffix,
        definition: this.getDefinitionGroupTitle(),
        object: this.getObjectGroupTitle(),
        type: 'group',
        children: []
      }
    },
    getDefinitionSectionTitle () {
      return JSON.parse(JSON.stringify(this.sectionDefinitionTitle))
    },
    getDefinitionGroupTitle () {
      return JSON.parse(JSON.stringify(this.groupDefinitionTitle))
    },
    getDefinitionQuestionTitle () {
      return JSON.parse(JSON.stringify(this.questionDefinitionTitle))
    },
    getObjectSectionTitle (sectionObj) {
      var object = null
      if (sectionObj) {
        object = transport.methods.getRequestObjectById(DEFINITON_SECTION_TITLE_ID, [sectionObj])
      } else {
        object = transport.methods.getEmptyRequestObject([this.sectionDefinitionTitle])[0]
        object.languageValue = transport.methods.getEmptyRequestMultilanguageObject(this.sectionDefinitionTitle)
      }
      return JSON.parse(JSON.stringify(object))
    },
    getObjectGroupTitle (groupObj) {
      var object = null
      if (groupObj) {
        object = transport.methods.getRequestObjectById(DEFINITON_GROUP_TITLE_ID, [groupObj])
      } else {
        object = transport.methods.getEmptyRequestObject([this.groupDefinitionTitle])[0]
        object.languageValue = transport.methods.getEmptyRequestMultilanguageObject(this.groupDefinitionTitle)
      }
      return JSON.parse(JSON.stringify(object))
    },
    getObjectQuestionTitle (questionObj) {
      var object = null
      if (questionObj) {
        object = transport.methods.getRequestObjectById(DEFINITON_QUESTION_TITLE_ID, [questionObj])
      } else {
        object = transport.methods.getEmptyRequestObject([this.questionDefinitionTitle])[0]
        object.languageValue = transport.methods.getEmptyRequestMultilanguageObject(this.questionDefinitionTitle)
      }
      return JSON.parse(JSON.stringify(object))
    },
    doQuestionsSearch () {
      this.questionSearcherTotal = 0
      this.questionSearcherCount = 0
      for (var i = 0; i < this.definitionQuestions.length; i++) {
        var question = this.definitionQuestions[i]
        question.show = false
        if (!this.questionSearcher || this.questionSearcher.trim() === '') {
          this.questionSearcherTotal += 1
          if (this.questionSearcherTotal <= QUESTIONS_SEARCHER_RESULTS) {
            this.questionSearcherCount += 1
            question.show = true
          }
        } else {
          if (
            question.value.toLowerCase().indexOf(this.questionSearcher.toLowerCase().trim()) > -1 ||
            question.key.toLowerCase().indexOf(this.questionSearcher.toLowerCase().trim()) > -1
          ) {
            this.questionSearcherTotal += 1
            if (this.questionSearcherTotal <= QUESTIONS_SEARCHER_RESULTS) {
              this.questionSearcherCount += 1
              question.show = true
            }
          }
        }
      }
    },
    aliasUsed (key) {
      var result = false
      if (this.sectionWrappers) {
        for (var i = 0; i < this.sectionWrappers.length && !result; i++) {
          var section = this.sectionWrappers[i]
          for (var j = 0; j < section.children.length && !result; j++) {
            var group = section.children[j]
            for (var k = 0; k < group.children.length && !result; k++) {
              var question = group.children[k]
              if (question.key === key) {
                result = true
              }
            }
          }
        }
      }
      return result
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    copy (fromLanguage) {
      this.textCopyOrTranslate('copy', fromLanguage)
    },
    translate (fromLanguage) {
      this.textCopyOrTranslate('translate', fromLanguage)
    },
    textCopyOrTranslate (operation, fromLanguage) {
      for (var i = 0; i < this.sectionWrappers.length; i++) {
        var section = this.sectionWrappers[i]
        this.translateCopyObject(section, fromLanguage, (i === 0), (i === this.sectionWrappers.length - 1), operation)
      }
    },
    translateCopyObject (obj, fromLanguage, first, last, operation) {
      if (obj.definition && obj.object) {
        var textValue = transport.methods.getLanguageValue(obj.object, fromLanguage.key)

        if (textValue.trim() !== '' && obj.object.languageValue && obj.object.languageValue.length > 1) {
          this.translateCopyLanguage(textValue, fromLanguage, 0, obj.object, first, last, operation)
        }

        if (obj.tasks) {
          for (var j = 0; j < obj.tasks.length; j++) {
            var task = obj.tasks[j]

            var nameObject = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKNAME_ID, [task.object])
            var taskNameTextValue = transport.methods.getLanguageValue(nameObject, fromLanguage.key)
            if (taskNameTextValue.trim() !== '' && nameObject.languageValue && nameObject.languageValue.length > 1) {
              this.translateCopyLanguage(taskNameTextValue, fromLanguage, 0, nameObject, first, last, operation)
            }

            var descObject = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKDESC_ID, [task.object])
            var taskDescTextValue = transport.methods.getLanguageValue(descObject, fromLanguage.key)
            if (taskDescTextValue.trim() !== '' && descObject.languageValue && descObject.languageValue.length > 1) {
              this.translateCopyLanguage(taskDescTextValue, fromLanguage, 0, descObject, first, last, operation)
            }
          }
        }

        if (obj.children) {
          for (var i = 0; i < obj.children.length; i++) {
            var childObj = obj.children[i]
            this.translateCopyObject(childObj, fromLanguage, first, last, operation)
          }
        }
      }
    },
    translateCopyLanguage (text, fromLanguage, index, object, first, last, operation) {
      var languages = object.languageValue
      if (index < languages.length) {
        if (first) {
          this.translating = true
        }
        var language = languages[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          // translate operation
          if (operation === 'translate') {
            translate(
              this.apiparams.translateUrl,
              this.apiparams.translateKey,
              text,
              fromLanguage.key,
              language.key
            )
              .then(translation => {
                object = transport.methods.setLanguageValue(object, translation.translatedText, translation.targetLang)
                this.translateCopyLanguage(text, fromLanguage, ++index, object, first, last, operation)
              })
              .catch(err => {
                console.error(err)
                if (last) {
                  this.refreshRepeatableGroup()
                  this.translating = false
                }
              })

          // copy operation
          } else {
            object = transport.methods.setLanguageValue(object, text, language.key)
            this.translateCopyLanguage(text, fromLanguage, ++index, object, first, last, operation)
          }
        }
        this.translateCopyLanguage(text, fromLanguage, ++index, object, first, last, operation)
      } else {
        var self = this
        setTimeout(function () {
          self.$emit('validateMandatory', moment().valueOf(), self.object)
          if (last) {
            self.refreshRepeatableGroup()
            self.translating = false
          }
        }, 500)
      }
    },
    refreshRepeatableGroup () {
      var sections = []
      for (var i = 0; i < this.sectionWrappers.length; i++) {
        var section = this.sectionWrappers[i]
        var sectionObj = transport.methods.getEmptyRequestObject([this.sectionDefinition], true)
        var sectionObjTitle = transport.methods.getRequestObjectById(DEFINITON_SECTION_TITLE_ID, sectionObj)
        sectionObjTitle.languageValue = section.object.languageValue

        var tasks = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASK_ID, sectionObj)
        if (tasks) {
          tasks.children = []
          for (var l = 0; l < section.tasks.length; l++) {
            var sectionTask = section.tasks[l]

            var sectionTaskObj = transport.methods.getEmptyRequestObject([this.sectionTaskDefinition], true)
            var sectionTaskIdObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKID_ID, sectionTaskObj)
            sectionTaskIdObj.textValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKID_ID, [sectionTask.object]).textValue
            var sectionTaskNameObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKNAME_ID, sectionTaskObj)
            sectionTaskNameObj.languageValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKNAME_ID, [sectionTask.object]).languageValue
            var sectionTaskDescObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKDESC_ID, sectionTaskObj)
            sectionTaskDescObj.languageValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKDESC_ID, [sectionTask.object]).languageValue
            var sectionTaskScopeObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKSCOPE_ID, sectionTaskObj)
            sectionTaskScopeObj.domainValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKSCOPE_ID, [sectionTask.object]).domainValue
            var sectionTaskStateObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKSTATE_ID, sectionTaskObj)
            sectionTaskStateObj.domainValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKSTATE_ID, [sectionTask.object]).domainValue
            var sectionTaskTypeObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKTYPE_ID, sectionTaskObj)
            sectionTaskTypeObj.domainValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKTYPE_ID, [sectionTask.object]).domainValue
            var sectionTaskPersistObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKPERSIST_ID, sectionTaskObj)
            sectionTaskPersistObj.domainValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKPERSIST_ID, [sectionTask.object]).domainValue
            var sectionTaskEndpointObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKENDPOINT_ID, sectionTaskObj)
            sectionTaskEndpointObj.textValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKENDPOINT_ID, [sectionTask.object]).textValue
            var sectionTaskMenuIdObj = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKMENUID_ID, sectionTaskObj)
            sectionTaskMenuIdObj.textValue = transport.methods.getRequestObjectById(DEFINITON_SECTION_TASKMENUID_ID, [sectionTask.object]).textValue

            tasks.children.push(sectionTaskObj[0])
          }
        }

        var groups = transport.methods.getRequestObjectById(DEFINITON_GROUP_ID, sectionObj)
        groups.children = []
        for (var j = 0; j < section.children.length; j++) {
          var group = section.children[j]

          var groupObj = transport.methods.getEmptyRequestObject([this.groupDefinition], true)
          var groupObjTitle = transport.methods.getRequestObjectById(DEFINITON_GROUP_TITLE_ID, groupObj)
          groupObjTitle.languageValue = group.object.languageValue

          var questions = transport.methods.getRequestObjectById(DEFINITON_QUESTION_ID, groupObj)
          questions.children = []
          for (var k = 0; k < group.children.length; k++) {
            var question = group.children[k]

            var questionObj = transport.methods.getEmptyRequestObject([this.questionDefinition], true)
            var questionObjTitle = transport.methods.getRequestObjectById(DEFINITON_QUESTION_TITLE_ID, questionObj)
            questionObjTitle.languageValue = question.object.languageValue

            var questionObjAlias = transport.methods.getRequestObjectById(DEFINITON_QUESTION_ALIAS_ID, questionObj)
            var questionCopy = JSON.parse(JSON.stringify(question))
            delete questionCopy.definition
            delete questionCopy.object
            delete questionCopy.task
            questionObjAlias.domainValue.push(questionCopy)

            questions.children.push(questionObj[0])
          }

          groups.children.push(groupObj[0])
        }

        sections.push(sectionObj[0])
      }

      this.object.children = sections
    },
    validateMandatory (timeEvent, requestObject) {
      this.refreshRepeatableGroup()
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    editingQuestion (editingQuestion) {
      this.isEditingQuestion = editingQuestion
      this.$emit('editingQuestion', this.isEditingQuestion)
    },
    questionDeleted (questionKey) {
      // Delete definitively from group
      this.deleteQuestionFromGroup(this.sectionWrappers, questionKey)
      this.refreshSections()
    },
    deleteQuestionFromGroup (groups, key) {
      var deleted = false

      for (var i = 0; i < groups.length && !deleted; i++) {
        var group = groups[i]
        if (group.id) {
          deleted = this.deleteQuestionFromGroup(group.children, key)
        } else if (group.key && group.key === key) {
          groups.splice(i, 1)
          group.forDelete = false
          this.definitionQuestions.splice(0, 0, group)
          this.isEditingQuestion = false
          deleted = true
        }
      }

      return deleted
    },
    getLang (key) {
      return language(this.language, key)
    },
    deleteTask (sectionIdx, taskIdx) {
      this.sectionWrappers[sectionIdx].tasks.splice(taskIdx, 1)
      this.refreshRepeatableGroup()
    },
    refreshTask (object) {
      this.refreshRepeatableGroup()
    },
    addTask (sectionsIdx) {
      var taskObj = null
      if (this.sectionTaskDefinition) {
        taskObj = transport.methods.getEmptyRequestObject([this.sectionTaskDefinition], true)[0]
      }

      var newTaskObject = {
        object: taskObj
      }
      this.sectionWrappers[sectionsIdx].tasks.push(newTaskObject)
      this.refreshRepeatableGroup()
    }
  },
  watch: {
    object (object) {
      if (!object.children || object.children.length === 0) {
        this.initDefinitionBuilder()
      }
    },
    definitionId (definitionId) {
      this.initDefinitionBuilder()
    }
  }
}
</script>

<style lang="scss">
#detail {
  .definition-builder {
    .questions_searcher {
      &.questions_searcher_fixed {
        top: 145px;
        bottom: 90px;
        left: 118px;
      }
    }
  }

  .modifying {
    .definition-builder {
      .questions_searcher {
        &.questions_searcher_fixed {
          bottom: 75px;
        }
      }
    }
  }
}
.get-singlefile-individual,
.get-singlefile-professional,
.get-singlefile-company,
.get-indicators-individual,
.get-indicators-professional,
.get-indicators-company {
  .definition-builder {
    .questions_searcher {
      &.questions_searcher_fixed {
        .language {
          top: 165px;
        }
      }
    }
  }
}
.definition-builder {
  [data-simplebar] {
    position: absolute;
    top: 72px;
    width: 94%;
    bottom: 0;
  }

  .definition-wrappers {
    [data-simplebar] {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .sectionTaskTitle {
    display: block;
    margin: 20px 0 0;
    font-family: 'Noto Sans';
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.9;
    letter-spacing: normal;
    color: #4599a4;
  }

  .addSectionTask {
    border: 1px solid #4599a4;
    margin-top: 5px;
    padding: 3px 12px 1px;
    font-size: 13px;
    background-color: #5dbecb;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;

    vertical-align: middle;
    .sherpa-icon {
      font-size: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }

  .group {
    padding: 0 !important;
    margin: 0 !important;

    .repeatable {
      margin: 0;
      padding: 0;
    }
  }

  .questions {
    display: inline-block;
    margin-right: 6px;
    margin-bottom: 6px;
    padding: 4px 10px;
    border-radius: 3px;
    border: 1px dashed #6bceda;
    background-color: #f3feff;
    position: relative;
    cursor: all-scroll;
    min-width: 300px;

    .question {
      padding-right: 40px;
    }

    span {
      font-family: 'Noto Sans';
      font-size: 13px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: 0.4px;
      color: #4599a4;

      .key {
        font-weight: 100;
      }
    }
  }

  .questions.selected {
    background-color: white;
    border: 1px dashed #ffbf28;

    span {
      color: #858585;
    }

    button {
      span {
        color: #fff;
      }
    }
  }

  .questions_searcher {
    margin-bottom: 20px;
    transition: all 0.3s ease-in;
    position: relative;
    min-height: 155px;
    background-color: #f0f0f0;
    padding: 10px 0;

    .questions {
      cursor: all-scroll;
      width: 96%;
    }

    &.questions_searcher_fixed {
      position: fixed;
      margin: 0;
      top: 100px;
      bottom: 70px;
      overflow: hidden;
      max-width: 370px;
      min-width: 370px;
      left: 120px;
      padding: 0 0 10px 10px;

      [data-simplebar] {
        top: 120px !important;
      }
    }

    .questions-drag-area {
      float: left;
    }

    .searcher-input {
      width: 350px;
      position: fixed;
      background-color: #f0f0f0;
      z-index: 100;
      padding: 10px 0;

      input {
        border-radius: 3px;
        background-color: rgba(255,255,255,0.6);
        border: 1px solid #ffbf28;
        font-family: 'Noto Sans';
        font-size: 16px;
        padding: 2px 30px 3px 8px;
        width: 100%;
        color: #333;
        height: 33px;
        outline: none;
      }

      .sherpa-icon {
        position: absolute;
        color: #4599a4;
        top: 16px;
        right: 7px;
        font-size: 19px;
      }

      .searcher-count-results {
        font-style: italic;
        font-weight: 400;
        margin-top: 3px;
        margin-bottom: 2px;
        padding: 2px 0 0 0;
        display: block;
        font-size: 11px;
        font-stretch: normal;
        line-height: 1.1;
        letter-spacing: normal;
        color: #000;
        float: right;
      }
    }

    .language {
      width: 350px;
      position: fixed;
      top: 212px;
      background-color: #f0f0f0;
      z-index: 100;
      padding: 10px 0;

      .multiselect {
        cursor: pointer;
        width: calc(100% - 32px);
        display: inline-block;

        .arrow {
          left: initial;
          right: 10px;
        }

        .multiselect__tags,
        .multiselect__single {
          background-color: #fff;
          padding: 0;
        }
      }

      .translate {
        display: inline-block;
        position: absolute;
      }
    }
  }

  .definition-wrappers {
    .section_wrapper {
      position: relative;

      .add_items {
        width: 100%;
        height: 100%;

        img {
          position: absolute;
          left: 0;
          top: -10%;
          transform: rotateZ(-90deg);
        }

        span {
          position: absolute;
          top: 45%;
          left: 32%;
          font-family: 'Noto Sans';
          font-size: 1em;
          font-weight: 600;
          font-style: italic;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #ffbf28;
        }
      }

      .definition-wrapper {
        width: 100%;
        min-height: initial !important;
        display: inline-block;

        .multilanguageText {
          width: 100%;
          padding: 0 0 20px;
          min-height: initial;

          .w3-input {
            border: 1px dotted #b5b5b5;
            margin-bottom: 0;
            font-size: 21px;
          }
          .w3-input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #dfdfdf;
            font-style: italic;
          }
          .w3-input:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #dfdfdf;
            font-style: italic;
          }
          .w3-input::-ms-input-placeholder { /* Microsoft Edge */
            color: #dfdfdf;
            font-style: italic;
          }
        }
      }
    }

    .work-flow {
      margin-bottom: 20px;
      padding: 10px;
      width: 100%;
      border-radius: 3px;
      background-color: #fffcf5;
      border: 1px dashed #ffbf28;
      min-height: 120px;

      &:last-child {
        margin-bottom: 0;
      }

      > div > div.groups-drag-area {
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 3px;
      }

      > div > div.groups-drag-area {
        &.formGroupInitiated {
          border: 1px dotted #ffbf28;
          padding: 5px 5px 0;
          min-height: 40px;
        }
      }

      input {
        border-radius: 4px;
        background-color: rgba(255,255,255,0.6);
        font-family: 'Noto Sans';
        font-size: 14px;
        width: 100%;
        color: #000;
        outline: none;
        margin-bottom: 16px;
        font-weight: normal;
      }

      span.multiselect__placeholder,
      span.multiselect__single,
      span.multiselect__option span {
        font-weight: normal !important;
        font-size: 14px !important;
      }
    }

    .work-flow.newSection {
      min-height: initial;
      height: 100px;
    }
  }
}
</style>
